var entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

module.exports = (string) => {
  const result =  String(string).replace(/[&<>"'`=\/]/g, function (s) {
    return entityMap[s];
  });

  if (result === 'undefined') return undefined;
  if (result === 'null') return null;

  return result;
}
